import React from 'react'
import { red } from "@mui/material/colors"
import RegularButton from "components/CustomButtons/Button"
import { useDispatch } from "react-redux"
import { removeCashInvoiceNote } from "redux/actions/invoices/invoicesCashAction"
import DeleteIcon from '@mui/icons-material/Delete';
import { ButtonGroup } from '@mui/material'
import { columnsConfig, reasonNotesOptions } from "./config"

export const columns = (reasonSelect) => {
  const baseColumns = [
    {
      Header: columnsConfig.folio.label,
      filterable: true,
      accessor: columnsConfig.folio.name,
      filterMethod: (filter, row) =>
        row.folio.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: columnsConfig.quantity.label,
      filterable: true,
      accessor: columnsConfig.quantity.name,
      filterMethod: (filter, row) =>
        row.quantity.toLowerCase().includes(filter.value.toLowerCase()),
    },
  ];
  const discountColumn = reasonSelect === reasonNotesOptions.discount
    ? [{
      Header: "Desc.",
      filterable: true,
      accessor: "discountAmount",
      filterMethod: (filter, row) =>
        row.discountAmount?.toString().toLowerCase().includes(filter.value.toLowerCase()),
    },]
    : [];
  const restColumns = [
    {
      Header: columnsConfig.price.label,
      accessor: columnsConfig.price.name,
      filterable: true,
      filterMethod: (filter, row) =>
        row.price.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: columnsConfig.subTotal.label,
      accessor: columnsConfig.subTotal.name,
      filterable: true,
      filterMethod: (filter, row) =>
        row.subTotal.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: columnsConfig.iva.label,
      accessor: columnsConfig.iva.name,
      filterable: true,
      filterMethod: (filter, row) =>
        row.iva.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: columnsConfig.total.label,
      accessor: columnsConfig.total.name,
      filterable: true,
      filterMethod: (filter, row) =>
        row.total.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: "Acciones",
      Cell: ({ original }) => {
        const dispatch = useDispatch()

        const handleRemove = () => {
          dispatch(removeCashInvoiceNote(original.id))
        }
        return (
          <ButtonGroup size="small"
            sx={{
              float: 'right'
            }}>
            <RegularButton
              justIcon
              round
              size="sm"
              color="transparent"
              tooltip={columnsConfig.actions.ButtonTooltip}
              onClick={handleRemove}
            >
              <DeleteIcon style={{ color: red[500] }} />
            </RegularButton>
          </ButtonGroup>
        )
      }
    },
  ]
  return [...baseColumns, ...discountColumn, ...restColumns];
}